<template>
  <div>
    <div class="mainColor--text font-weight-bold mb-2">Not sure what keywords to select?</div>
    <div class="mainColor--text mb-2">Just share your general idea and our team will take care of keyword selection and content creation.</div>

    <v-textarea
      class="mb-2"
      outlined
      dense
      v-model="text"
      color="greenColor"
      counter="250"
      rows="3"
      placeholder="Share your content idea "
      :counter-value="countWords"
      :rules="[(v) => countWords(v) <= 250 || `Must be less than 250 words`]"
    >
    </v-textarea>

    <span class="mainColor--text">Reply-to email</span>
    <v-text-field
      class="mb-4"
      outlined
      dense
      v-model="email"
      hide-details
      color="greenColor"
    >
    </v-text-field>

    <div class="d-flex gap10">
      <v-btn
        color="profileAnchorColor"
        class="button-with-icon text-none whiteColor--text"
        tag="a"
        :disabled="!text || !email"
        :loading="submitting"
        @click="submit()"
      >
        Contact team
      </v-btn>
      <v-btn
        outlined
        class="button-with-icon text-none"
        tag="a"
        :disabled="submitting"
        @click="text = ''; email = user?.email; $emit('close');"
      >
        Cancel
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      text: '',
      email: '',
      submitting: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  methods: {
    submit() {
      this.submitting = true;
      return this.$store
        .dispatch('askForHelpWithKeywords', {
          body: {
            text: this.text,
            email: this.email,
          },
        })
        .then((response) => {
          if (response.data?.status === 'SUCCESS') {
            this.$notify({ group: 'info', type: 'success', text: 'Successfully sent.' })
            this.text = ''
            this.$emit('close');
            return
          }
          return Promise.reject()
        })
        .catch(() => {
          this.$notify({ group: 'info', type: 'error', text: 'An error happened.' })
        })
        .finally(() => {
          this.submitting = false;
        })
    }
  },
  mounted() {
    if (this?.user?.email) {
      this.email = this?.user?.email
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
